import { tv, VariantProps } from "@/utils";

export const helpText = tv({
  slots: {
    base: ["flex gap-1.5"],
  },
  variants: {
    status: {
      default: {
        base: [],
      },
      success: {
        base: ["text-green-500"],
      },
      danger: {
        base: ["text-red-500"],
      },
    },
    floating: {
      false: {
        base: ["mt-2"],
      },
      true: {
        base: ["absolute top-full", "translate-y-1"],
      },
    },
  },
});

export type HelpTextVariantProps = VariantProps<typeof helpText>;

export type HelpTextReturnVariantProps = ReturnType<typeof helpText>;
